import React from 'react';
import {Image, Link, Text} from '@sitecore-jss/sitecore-jss-react';
import PrintProps from "../TestNoParams/PrintProps";
import { ComponentProps } from '../../types/types';

const TestWithParams = (props: ComponentProps) => {
    const FieldsPart = props.fields? (() => (
        <>
            <Text field={props.fields?.heading} tag='p'/>
            <Link field={props.fields?.routableSitecoreLink}/>
            <Link field={props.fields?.link}/>
            <Image field={props.fields?.image}/>
        </>
    )) : (()=><p>Missing "fields" prop</p>);
    const ParamsPart = props.params ? (()=>(<p>{props.params?.testParam}</p>)) : (()=><p>Missing "params" prop</p>)

    return <div style={{backgroundColor: "white", border: "1px solid black", overflow: "hidden"}}>
        <p>TestWithParams Component</p>
        <FieldsPart/>
        <ParamsPart/>
        <PrintProps {...props}/>
    </div>;
};

export default TestWithParams;
